// extracted by mini-css-extract-plugin
export default {"main":"styles_main__7IdEG","img_side":"styles_img_side__tZRGA","form_side":"styles_form_side__VH8Di"};